import { Icon, IconSize, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { getTimeElapsed } from "@next-platform/client-common-core";

import { Row } from "@/components/customComponents";

type ChatsStatsProps = {
  timestamp: number | string | Date;
  interactionCount?: number;
};

const ChatsStats = ({ timestamp, interactionCount }: ChatsStatsProps) => {
  if (!timestamp && !interactionCount) {
    return null;
  }

  return (
    <Row className="items-center gap-[4px]">
      {timestamp && (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-10">
          {getTimeElapsed(timestamp)}
        </Text>
      )}
      {!!interactionCount && timestamp && (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-600">
          •
        </Text>
      )}
      {!!interactionCount && (
        <div className="flex items-center gap-[2px]">
          <Icon icon={"MessageSquareText"} size={IconSize.XSMALL} className="text-gray-10" />
          <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-10">
            {interactionCount}
          </Text>
        </div>
      )}
    </Row>
  );
};

export default ChatsStats;
